

import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class ContentFilter extends Vue {
    @Prop({ default: '' }) readonly fileData!: string;
    @Prop({ default: '' }) readonly fileName!: string;

    downloadData() {
        const blob = new Blob([this.fileData], {type: 'text/plain'});
        const a = document.createElement('a');
        a.href = window.URL.createObjectURL(blob);
        a.download = this.fileName;
        a.click();
    }
}
